import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialPersonnelTrainingState: Dtos.PersonnelTraining & IRegistrationFormState = {
    id: null,
    personnelId: null,
    personnel: null,
    trainingTypeId: null,
    trainingType: null,
    dateCompleted: null,
    comments: null,
    courseModule: null,
    provider: null,
    certificateNumber: null,
    trainingGeneralSystemTypeId: null,
    trainingGeneralSystemType: null,
    certificate: null,
    additionalCertificate: null,
    sourceDocuments: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface IPersonnelTrainingReduxFormState {
    id: IFieldState<number>,
    personnelId: IFieldState<number>,
    personnel: IFieldState<Dtos.Personnel>,
    trainingTypeId: IFieldState<number>,
    trainingType: IFieldState<Dtos.TrainingType>,
    dateCompleted: IFieldState<string>,
    comments: IFieldState<string>,
    courseModule: IFieldState<string>,
    provider: IFieldState<string>,
    certificateNumber: IFieldState<string>,
    trainingGeneralSystemTypeId: IFieldState<number>,
    trainingGeneralSystemType: IFieldState<Dtos.TrainingGeneralSystemType>,
    certificate: IFieldState<string>,
    additionalCertificate: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
}
